import React, {useEffect} from "react";
import {Grid, IconButton} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import {RootGrid, HeaderTypography} from "./taxonomy";
import {PocGeneralProperties} from "../../../../settings/default_properties";
import SettingModifier from "../components/setting_modifier";
import {getAttributeSets as utilGetAttributeSets} from "../../../../../utils/utils";
import EnhancedErrorDialog from "../../../../../components/EnhancedErrorDialog";
import {pageContentGap} from "../../../../../theme";

interface ErrorState {
    open: boolean;
    errorHeader: string;
    errorMessage: string;
}

interface GeneralProps {
    setTitle?: (title: string, flag?: boolean) => void;
    isRetailer?: boolean;
    location: {
        key?: string;
    };
    history: {
        push: (path: string) => void;
        goBack: () => void;
    };
}

const iconButtonSx = (theme: any) => ({
    backgroundColor: "white",
    border: "none",
    borderRadius: "6px",
    "& svg": { color: "rgba(0, 0, 0, 0.54)" }
});
export default function General(props: GeneralProps) {
    const {setTitle} = props;
    const [error, setError] = React.useState<ErrorState>({open: false, errorHeader: "", errorMessage: ""});
    const [attributeSets, setAttributeSets] = React.useState<any[]>([]);
    useEffect(() => {
        if(setTitle) {
            setTitle('POC General Settings', true);
        }
        const getAttributeSets = async () => {
            const attributeSets = await utilGetAttributeSets(false, "", undefined, props.isRetailer);
            if (attributeSets.errorMessage) {
                setError(attributeSets);
            } else {
                setAttributeSets(attributeSets);
            }
        }
        getAttributeSets();
        // eslint-disable-next-line
    }, []);
    return (
        <RootGrid container
              style={{gap: pageContentGap, padding: "24px 14px 24px 14px", position: "relative"}}>
            <Grid container justifyContent={"space-between"} direction={"row"}>
                <Grid item container justifyContent={"flex-start"} alignItems={"center"} style={{gap: pageContentGap, width: "100%"}}>
                    <IconButton
                        sx={iconButtonSx}
                        style={{height: "36px", width: "36px", position: 'relative', zIndex: 1}}
                        onClick={(e) => {
                            e.preventDefault();
                            if (props.location.key === undefined)
                                props.history.push("/productonboardingcenter/catalog");
                            else
                                props.history.goBack();
                        }}
                        size="large">
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>
                    <HeaderTypography>
                        General Settings
                    </HeaderTypography>
                </Grid>
            </Grid>
            <PocGeneralProperties
                isMulti={false}
                options={attributeSets}
                template={(templateProps: any) => {
                    return <SettingModifier {...templateProps} />
                }}
            />
            <EnhancedErrorDialog open={error.open} onClose={() => setError({...error, open: false})}
                                 errorHeader={error.errorHeader} errorMessage={error.errorMessage}/>
        </RootGrid>
    );
}
